import {
  SORT_TYPES,
  TEAM_MEMBERS_TABLE_COLUMN_HEADERS,
  getPermissionOptionDisplayTextFromBoolean,
  getPermissionBooleanFromPermissionType,
} from '../../../constants'
import { StandardCompare, getName } from '../../../containers/Utilities'

export const sortTeamMembersIds = (
  sorts = {
    sortBy: TEAM_MEMBERS_TABLE_COLUMN_HEADERS.NAME,
    sortDirection: SORT_TYPES.ASC,
  },
  tMIds = [],
  teamMembersById = {},
) => {
  const {
    sortBy,
    sortDirection,
  } = sorts
  const teamMemberIds = [ ...tMIds ]
  let sortedTeamMemberIds = teamMemberIds

  if (teamMemberIds) {
    switch (sortBy) {
    case TEAM_MEMBERS_TABLE_COLUMN_HEADERS.NAME:
      sortedTeamMemberIds = teamMemberIds.sort((a, b) => {
        const teamMember1 = teamMembersById[a]
        const teamMember2 = teamMembersById[b]
        const teamMember1Name = getName(teamMember1.firstName, teamMember1.lastName, '')
        const teamMember2Name = getName(teamMember2.firstName, teamMember2.lastName, '')

        return StandardCompare.strings(teamMember1Name, teamMember2Name, sortDirection)
      })
      break
    case TEAM_MEMBERS_TABLE_COLUMN_HEADERS.EMAIL:
      sortedTeamMemberIds = teamMemberIds.sort((a, b) => StandardCompare.strings(teamMembersById[a].email, teamMembersById[b].email, sortDirection))
      break
    case TEAM_MEMBERS_TABLE_COLUMN_HEADERS.ADMIN_PERMISSION:
      sortedTeamMemberIds = teamMemberIds.sort((a, b) => {
        const teamMember1 = teamMembersById[a]
        const teamMember2 = teamMembersById[b]
        const permission1 = getPermissionOptionDisplayTextFromBoolean(teamMember1.permissions.isAdmin)
        const permission2 = getPermissionOptionDisplayTextFromBoolean(teamMember2.permissions.isAdmin)

        return StandardCompare.strings(permission1, permission2, sortDirection)
      })
      break
    case TEAM_MEMBERS_TABLE_COLUMN_HEADERS.PHYSICIAN_PERMISSION:
      sortedTeamMemberIds = teamMemberIds.sort((a, b) => {
        const teamMember1 = teamMembersById[a]
        const teamMember2 = teamMembersById[b]
        const permission1 = getPermissionOptionDisplayTextFromBoolean(teamMember1.permissions.isPhysician)
        const permission2 = getPermissionOptionDisplayTextFromBoolean(teamMember2.permissions.isPhysician)

        return StandardCompare.strings(permission1, permission2, sortDirection)
      })
      break
    default:
      // No sort, keep previous sort
      break
    }
  }

  return sortedTeamMemberIds
}

export const filterTeamMembersIds = (
  filters = {
    selectedId: undefined,
    selectedEmail: undefined,
    selectedAdminPermissionId: undefined,
    selectedPhysicianPermissionId: undefined,
  },
  teamMembersIds = [],
  teamMembersById = {},
) => {
  const {
    selectedId,
    selectedEmail,
    selectedAdminPermissionId,
    selectedPhysicianPermissionId,
  } = filters
  let filteredTeamMembersIds = teamMembersIds

  if (teamMembersIds) {
    if (selectedId) {
      filteredTeamMembersIds = filteredTeamMembersIds
        .filter(id => {
          const teamMember = teamMembersById[id]
          return teamMember.id === selectedId
        })
    }

    if (selectedEmail) {
      filteredTeamMembersIds = filteredTeamMembersIds
        .filter(id => {
          const teamMember = teamMembersById[id]
          const text = teamMember.email || ''
          return text.includes(selectedEmail)
        })
    }

    if (selectedAdminPermissionId) {
      filteredTeamMembersIds = filteredTeamMembersIds
        .filter(id => {
          const teamMember = teamMembersById[id]
          const {
            isAdmin,
          } = teamMember.permissions
          const selectedAdminPermission = getPermissionBooleanFromPermissionType(selectedAdminPermissionId)
          return isAdmin === selectedAdminPermission
        })
    }

    if (selectedPhysicianPermissionId) {
      filteredTeamMembersIds = filteredTeamMembersIds
        .filter(id => {
          const teamMember = teamMembersById[id]
          const {
            isPhysician,
          } = teamMember.permissions
          const selectedPhysicianPermission = getPermissionBooleanFromPermissionType(selectedPhysicianPermissionId)
          return isPhysician === selectedPhysicianPermission
        })
    }
  }

  return filteredTeamMembersIds
}



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/TeamMembersTable/Utilities.js